import React, { useContext, useEffect, useState } from "react";
import api from "../../../axiosConfig";
import { Row, Col, Card, Button, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHistory,
  faWrench,
  faExclamationTriangle,
  faSpinner,
  faScrewdriverWrench,
  faCogs,
} from "@fortawesome/free-solid-svg-icons";
import { MaintenanceContext } from "../../../contexts/MaintenanceContext";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import "./css/Overview.css";

const OverviewTab = () => {
  const {
    machines = [],
    recentActivities = [],
    loading,
    error,
  } = useContext(MaintenanceContext);

  const navigate = useNavigate();

  /* ✅ HOOK WAJIB DI DALAM COMPONENT */
  const [stockMinimumCount, setStockMinimumCount] = useState(0);
  const [totalTools, setTotalTools] = useState(0);
  const [toolsNeedRepair, setToolsNeedRepair] = useState(0);
  const [toolsUnderRepair, setToolsUnderRepair] = useState(0);
  const totalMachines = machines.length;
  const [stockMinimumToolsCount, setStockMinimumToolsCount] = useState(0);
  const [toolsHistory, setToolsHistory] = useState([]);
  const [loadingToolsHistory, setLoadingToolsHistory] = useState(false);
  const [errorToolsHistory, setErrorToolsHistory] = useState(null);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const isMinimum = queryParams.get("minimum") === "true";

  const needMaintenanceCount = machines.filter(
    (m) => m.status === "Need Maintenance",
  ).length;
  const underMaintenanceCount = machines.filter(
    (m) => m.status === "Under Maintenance",
  ).length;

  const handleCardClick = (status) => {
    let url = "/maintenance-dashboard/machines";
    if (status) url += `?status=${status}`;
    navigate(url);
  };
  const handleCardClickTools = (status) => {
    let url = "/maintenance-dashboard/tools";
    if (status) url += `?status=${status}`;
    navigate(url);
  };

  useEffect(() => {
    const fetchToolsHistory = async () => {
      setLoadingToolsHistory(true);
      try {
        const res = await api.get("/maintenance/tools/history");

        const sorted = (res.data || [])
          .sort((a, b) => new Date(b.start_time) - new Date(a.start_time))
          .slice(0, 5); // 🔥 ambil 5 terbaru saja

        setToolsHistory(sorted);
        setErrorToolsHistory(null);
      } catch (err) {
        console.error("Gagal ambil history tools", err);
        setErrorToolsHistory("Gagal memuat aktivitas tools");
      } finally {
        setLoadingToolsHistory(false);
      }
    };

    fetchToolsHistory();
  }, []);

  useEffect(() => {
    const fetchStockMinimumTools = async () => {
      try {
        const res = await api.get("/stock-tools");

        const minimumTools = (res.data.data || []).filter(
          (t) => Number(t.stock_qty) <= 1,
        );

        setStockMinimumToolsCount(minimumTools.length);
      } catch (err) {
        console.error("Gagal ambil stock minimum tools", err);
        setStockMinimumToolsCount(0);
      }
    };

    fetchStockMinimumTools();
  }, []);

  useEffect(() => {
    const fetchToolsMaintenance = async () => {
      try {
        const res = await api.get("/maintenance/tools");

        const needRepair = res.data.filter(
          (t) => t.status === "BUTUH_DIPERBAIKI",
        ).length;

        const underRepair = res.data.filter(
          (t) => t.status === "SEDANG_DIPERBAIKI",
        ).length;

        setToolsNeedRepair(needRepair);
        setToolsUnderRepair(underRepair);
      } catch (err) {
        console.error("Gagal ambil maintenance tools", err);
        setToolsNeedRepair(0);
        setToolsUnderRepair(0);
      }
    };

    fetchToolsMaintenance();
  }, []);

  useEffect(() => {
    const fetchTotalTools = async () => {
      try {
        const res = await api.get("/maintenance/tools/list");
        setTotalTools(res.data?.length || 0);
      } catch (err) {
        console.error("Gagal ambil total tools", err);
        setTotalTools(0);
      }
    };

    fetchTotalTools();
  }, []);

  /* 🔥 AMBIL JUMLAH STOCK MINIMUM */
  useEffect(() => {
    const fetchStockMinimum = async () => {
      try {
        const res = await api.get("/stock-items", {
          params: {
            minimum: "true",
            lifetime_type: "long,short", // 🔥 FILTER UTAMA
          },
        });

        setStockMinimumCount(res.data.length);
      } catch (err) {
        console.error("Gagal ambil stock minimum", err);
      }
    };

    fetchStockMinimum();
  }, []);

  return (
    <div className="overview-page mb-0 p-0" style={{ marginTop: "-15px" }}>
      {/* ================= STATISTICS ================= */}

      <Row>
        <Col md={6}>
          <Card className="p-2">
            <Row className="stats-row">
              <Col md={6}>
                <Card
                  className="stats-card text-center"
                  style={{
                    height: "109px",
                    cursor: "pointer",
                  }}
                  onClick={() => handleCardClick(null)}
                >
                  <Card.Body className="p-2 border">
                    <FontAwesomeIcon
                      icon={faCogs}
                      size="2x"
                      className="text-primary "
                    />

                    <h6 className="mb-0">Total Mesin</h6>
                    <p className="number-highlight text-primary mb-0 fs-5">
                      {totalMachines}
                    </p>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={6}>
                <Card
                  className="stats-card text-center"
                  style={{ height: "109px", cursor: "pointer" }}
                  onClick={() => handleCardClick(null)}
                >
                  <Card.Body className="p-2 border">
                    <FontAwesomeIcon
                      icon={faWrench}
                      size="2x"
                      className="text-info "
                    />
                    <h6 className="mb-0">Dalam Perbaikan</h6>
                    <p className="number-highlight text-info mb-0 fs-5">
                      {underMaintenanceCount}
                    </p>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={6}>
                <Card
                  className="stats-card text-center"
                  style={{ height: "109px", cursor: "pointer" }}
                  onClick={() => handleCardClick(null)}
                >
                  <Card.Body className="p-2 border">
                    <FontAwesomeIcon
                      icon={faExclamationTriangle}
                      size="2x"
                      className="text-warning "
                    />
                    <h6 className="mb-0">Butuh Perbaikan</h6>
                    <p className="number-highlight text-warning mb-0 fs-5">
                      {needMaintenanceCount}
                    </p>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={6}>
                <Card
                  className="stats-card text-center"
                  style={{ height: "109px", cursor: "pointer" }}
                  onClick={() =>
                    navigate("/maintenance-dashboard/stock?minimum=true")
                  }
                >
                  <Card.Body className="p-2 border">
                    <h2 style={{ size: "1x" }}>⛔</h2>

                    <h6 className="mb-0" style={{ marginTop: "-5px" }}>
                      Stock Minimum Item
                    </h6>
                    <p className="number-highlight text-danger mb-0 fs-5">
                      {stockMinimumCount}
                    </p>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            {/* ================= RECENT ACTIVITIES ================= */}
            <Card className="dashboard-card p-1 mb-0">
              <Card.Header
                className="d-flex justify-content-between align-items-center"
                style={{ background: "#1e3a8a", color: "#fff" }}
              >
                <span>Aktivitas Maintenance Mesin</span>
                <Button
                  variant="outline-light"
                  size="sm"
                  onClick={() => navigate("/maintenance-dashboard/history")}
                >
                  <FontAwesomeIcon icon={faHistory} className="me-1" /> Lihat
                  Semua
                </Button>
              </Card.Header>

              <Card.Body className="p-0">
                <RecentActivitiesSection
                  recentActivities={recentActivities}
                  loading={loading}
                  error={error}
                />
              </Card.Body>
            </Card>
          </Card>
        </Col>
        <Col md={6}>
          <Card className="p-2">
            <Row className="stats-row">
              <Col md={6}>
                <Card
                  className="stats-card text-center"
                  style={{ height: "109px", cursor: "pointer" }}
                  onClick={() => handleCardClickTools(null)}
                >
                  <Card.Body className="p-2 border">
                    <FontAwesomeIcon
                      icon={faScrewdriverWrench}
                      size="2x"
                      className="text-primary"
                    />
                    <h6 className="mb-0">Total Tools</h6>
                    <p className="number-highlight text-primary mb-0 fs-5">
                      {totalTools}
                    </p>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={6}>
                <Card
                  className="stats-card text-center"
                  style={{ height: "109px", cursor: "pointer" }}
                  onClick={() => handleCardClickTools("Under Maintenance")}
                >
                  <Card.Body className="p-2 border">
                    <FontAwesomeIcon
                      icon={faWrench}
                      size="2x"
                      className="text-info "
                    />
                    <h6 className="mb-0">Dalam Perbaikan</h6>
                    <p className="number-highlight text-info mb-0 fs-5">
                      {toolsUnderRepair}
                    </p>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={6}>
                <Card
                  className="stats-card text-center"
                  style={{ height: "109px", cursor: "pointer" }}
                  onClick={() => handleCardClickTools("Need Maintenance")}
                >
                  <Card.Body className="p-2 border">
                    <FontAwesomeIcon
                      icon={faExclamationTriangle}
                      size="2x"
                      className="text-warning "
                    />
                    <h6 className="mb-0">Butuh Perbaikan</h6>
                    <p className="number-highlight text-warning mb-0 fs-5">
                      {toolsNeedRepair}
                    </p>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={6}>
                <Card
                  className="stats-card text-center"
                  style={{ height: "109px", cursor: "pointer" }}
                  onClick={() =>
                    navigate("/maintenance-dashboard/stock/tools-minimum")
                  }
                >
                  <Card.Body className="p-2 border">
                    <h2 style={{ size: "1x" }}>⛔</h2>
                    <h6 className="mb-0" style={{ marginTop: "-5px" }}>
                      Stock Minimum Tools
                    </h6>
                    <p className="number-highlight text-danger mb-0 fs-5">
                      {stockMinimumToolsCount}
                    </p>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            {/* ================= RECENT ACTIVITIES ================= */}
            <Card className="dashboard-card p-1 mb-0">
              <Card.Header
                className="d-flex justify-content-between align-items-center"
                style={{ background: "#1e3a8a", color: "#fff" }}
              >
                <span>Aktivitas Maintenance Tools</span>
                <Button
                  variant="outline-light"
                  size="sm"
                  onClick={() =>
                    navigate("/maintenance-dashboard/stock/history-tools")
                  }
                >
                  <FontAwesomeIcon icon={faHistory} className="me-1" /> Lihat
                  Semua
                </Button>
              </Card.Header>

              <Card.Body className="p-2">
                <RecentActivitiesToolsSection
                  activities={toolsHistory}
                  loading={loadingToolsHistory}
                  error={errorToolsHistory}
                />
              </Card.Body>
            </Card>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

/* ================= RECENT ACTIVITIES ================= */

const RecentActivitiesSection = ({ recentActivities, loading, error }) => {
  const calculateDuration = (start, end) => {
    if (!start) return "N/A";
    const finish = end ? new Date(end) : new Date();
    const diff = Math.floor((finish - new Date(start)) / 60000);
    return `${diff} menit`;
  };

  if (loading)
    return (
      <div className="text-center p-5">
        <FontAwesomeIcon
          icon={faSpinner}
          spin
          size="3x"
          className="text-primary mb-3"
        />
        <p>Memuat data...</p>
      </div>
    );

  if (error)
    return (
      <div className="text-center p-5 text-danger">
        <p>{error}</p>
      </div>
    );

  if (!recentActivities.length)
    return (
      <div className="text-center p-5">
        <FontAwesomeIcon
          icon={faHistory}
          size="3x"
          className="text-muted mb-3"
        />
        <p>Belum ada aktivitas</p>
      </div>
    );

  return (
    <div className="activity-scroll">
      <Table hover className="mb-0">
        <thead className="table-light" style={{ position: "sticky", top: 0 }}>
          <tr>
            <th>KODE</th>
            <th>MESIN</th>
            <th>TANGGAL</th>
            <th>MULAI</th>
            <th>SELESAI</th>
            <th>STATUS</th>
          </tr>
        </thead>
        <tbody>
          {recentActivities.map((a, index) => {
            const start = a.startTime;
            const end = a.endTime;

            return (
              <tr key={a.id || index}>
                <td>{a.machine?.code || "-"}</td>
                <td>{a.machine?.name || "-"}</td>
                <td>
                  {start ? new Date(start).toLocaleDateString("id-ID") : "N/A"}
                </td>
                <td>
                  {start ? new Date(start).toLocaleTimeString("id-ID") : "N/A"}
                </td>
                <td>{end ? new Date(end).toLocaleTimeString("id-ID") : "-"}</td>

                <td>
                  <span
                    className={`status-badge ${end ? "completed" : "in-progress"}`}
                  >
                    {end ? "Selesai" : "Sedang Berlangsung"}
                  </span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};

const RecentActivitiesToolsSection = ({ activities, loading, error }) => {
  if (loading)
    return (
      <div className="text-center p-5">
        <FontAwesomeIcon icon={faSpinner} spin size="3x" />
        <p>Memuat data...</p>
      </div>
    );

  if (error)
    return (
      <div className="text-center p-5 text-danger">
        <p>{error}</p>
      </div>
    );

  if (!activities.length)
    return (
      <div className="text-center p-5">
        <FontAwesomeIcon icon={faHistory} size="3x" className="text-muted" />
        <p>Belum ada aktivitas</p>
      </div>
    );

  return (
    <div className="activity-scroll">
      <Table hover className="mb-0">
        <thead className="table-light sticky-top">
          <tr>
            <th>KODE</th>
            <th>PART</th>
            <th>MULAI</th>
            <th>SELESAI</th>
            <th>STATUS</th>
          </tr>
        </thead>
        <tbody>
          {activities.map((h, i) => (
            <tr key={h.id || i}>
              <td>{h.kode || "-"}</td>
              <td>{h.part_name || "-"}</td>

              <td>
                {h.start_time
                  ? new Date(h.start_time).toLocaleString("id-ID")
                  : "-"}
              </td>
              <td>
                {h.end_time
                  ? new Date(h.end_time).toLocaleString("id-ID")
                  : "-"}
              </td>
              <td>
                <span
                  className={`status-badge ${
                    h.judgment === "NG" ? "ng" : "ok"
                  }`}
                >
                  {h.judgment}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default OverviewTab;
